import {
	GET_RETURN_BULK_PENDING_REPORT_REQUEST,
	GET_RETURN_BULK_PENDING_REPORT_SUCCESS,
	GET_RETURN_BULK_PENDING_REPORT_ERROR
} from "../actions/types";
export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_RETURN_BULK_PENDING_REPORT_REQUEST:
			return {
				loading: true,
			};
		case GET_RETURN_BULK_PENDING_REPORT_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_RETURN_BULK_PENDING_REPORT_ERROR:
			return {
				...state,
				loading: false,
			};
		default:
			return state;
	}
}
